import OrderQRCode from './components';

export default {
  path: '/qr/:orderReferenceId',
  key: '/qr/',
  exact: true,
  component: OrderQRCode,
};
